<!--
 * @Author: zhaoliang
 * @Date: 2024-09-26 18:34:08
 * @LastEditTime: 2025-09-01 17:33:58
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/SwitchMembership/RemoveMembership/index.vue
 *
-->
<template>
  <div class="remove-membership-container">
    <!-- <h1 class="global-title">{{ $t('mbs-remove-membership') }}</h1> -->
    <h1 class="global-title">{{ $t('mbs-select-delink') }}</h1>
    <div class="content-wrap">
      <p class="tips-title">{{ currentContext.title }}</p>
      <p class="tips-desc">
        {{ currentContext.desc }}
      </p>
      <div class="card-wrap">
        <div class="membership-info">
          <div class="card-logo">
            <img v-if="card.bankLogoThumbNails" :src="card.bankLogoThumbNails" alt="bank logo" />
          </div>
          <p class="membership-no">{{ formatCardNo(card.dragonCode) }}</p>
          <div class="membership-others-info">
            <div class="membership-status">
              <span>{{ $t('entitlement-refresh') }}</span>
              <span>: </span>
              <span>{{ card.cardValidDate }}</span>
            </div>
            <div class="card-info">
              <span>{{ card.issueName }}</span>
              <span>, </span>
              <span>{{ card.cardType }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <button @click="handleConfirm" class="confirm-btn" :class="{ isLoading }">
        <img v-if="isLoading" src="../../../assets/images/icon-loading-spinner.svg" alt="loading" />
        <span>{{ currentContext.confirmText }}</span>
      </button>
      <button @click="handleBack" class="cancel-btn">{{ currentContext.cancelText }}</button>
    </div>
  </div>
</template>
<script>
  import { formatCardNo } from '@/utils/index';
  import { mapState } from 'vuex';

  export default {
    name: 'RemoveMembership',
    data() {
      return {
        card: {
          issuerName: '',
          bankLogo: '',
          cardHolder: '',
          dragonCode: '',
          cardValidDate: '',
          last4CreditNo: '',
          tradeMarkAgentName: '',
          status: 0,
        },
        isLoading: false,
        currentContext: {},
        currentStatus: 'removeContext', // 'removeContext' 'unbaleContext' 'removingContext'
        removeContext: {
          title: this.$i18n.t('delink-remove-context-title'),
          desc: this.$i18n.t('delink-remove-context-desc'),
          cancelText: this.$i18n.t('btn-cancel'),
          confirmText: this.$i18n.t('delink-remove-context-confirm-text'),
        },
        unbaleContext: {
          title: this.$i18n.t('delink-unbale-context-title'),
          desc: this.$i18n.t('delink-unbale-context-desc'),
          cancelText: this.$i18n.t('btn-cancel'),
          confirmText: this.$i18n.t('delink-unbale-context-confirm-text'),
        },
        removingContext: {
          title: this.$i18n.t('delink-remove-context-title'),
          desc: this.$i18n.t('delink-remove-context-desc'),
          cancelText: this.$i18n.t('btn-cancel'),
          confirmText: this.$i18n.t('delink-removing-context-confirm-text'),
        },
      };
    },
    mounted() {
      const card = sessionStorage.getItem('removeCardInfo');
      this.card = card ? JSON.parse(card) : {};
      this.currentContext = this.removeContext;
      this.currentStatus = 'removeContext';
    },
    computed: {
      ...mapState(['userInfo']),
    },
    methods: {
      formatCardNo,
      wrapperBrandTag(str) {
        const abc = (match, p1) => {
          return `<sup>${p1.slice(1, p1.length - 1)}</sup>`;
        };
        return str?.replace(/(\{[^{}]+\})/g, abc).replaceAll('®', '<sup>®</sup>');
      },
      getCardStatus(data) {
        const { status } = data;
        if (status === 8) return 'mbs-switch-card-suspended';
        if (status === 7) return 'mbs-switch-card-expired';
        return null;
      },
      setTitleColor(data) {
        const { status } = data;
        if (status === 8) return '#CC2222';
        if (status === 7) return '#CC2222';
      },
      handleBack() {
        this.$router.push({ name: 'SwitchMembership' });
      },
      handleConfirm() {
        if (this.currentStatus === 'removeContext') {
          this.handleSave();
        } else if (this.currentStatus === 'unbaleContext') {
          this.$router.push({ name: 'MyTrips' });
        }
      },
      handleSave() {
        this.isLoading = true;
        this.currentContext = this.removingContext;
        this.currentStatus = 'removingContext';
        const { userId, sessionId } = this.userInfo;
        this.$http.member.checkDelink({ id: this.card.id, userId, sessionId }).then(res => {
          if (res.state === '11') {
            if (res.payload.unfinishedOrderNum === 0) {
              this.$http.member.delinkCard({ id: this.card.id, userId, sessionId }).then(res => {
                if (res.state === '11') {
                  this.$router.push({ name: 'SwitchMembership' });
                } else {
                  this.$messageModal.show({
                    image: false,
                    closeIcon: true,
                    desc: res.note,
                    confirmBtn: 'ok',
                    justHide: true,
                    i18nNeed: false,
                  });
                  this.currentContext = this.removeContext;
                  this.currentStatus = 'removeContext';
                }
                this.isLoading = false;
              });
            } else {
              this.isLoading = false;
              this.currentContext = this.unbaleContext;
              this.currentStatus = 'unbaleContext';
            }
          } else {
            this.$messageModal.show({
              image: false,
              closeIcon: true,
              desc: res.note,
              confirmBtn: 'ok',
              justHide: true,
              i18nNeed: false,
            });
            this.isLoading = false;
            this.currentContext = this.removeContext;
            this.currentStatus = 'removeContext';
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .remove-membership-container {
    @include global-title();
    .global-title {
      margin-bottom: 32px;
    }

    .content-wrap {
      width: 960px;
      padding-bottom: 50px;
      border-bottom: 1px solid #8b9baa;
      .tips-title {
        @include font(24px, 600);
        line-height: 32px;
        margin-bottom: 18px;
      }
      .tips-desc {
        @include font(18px, 400);
        line-height: 24px;
        margin-bottom: 48px;
      }

      .card-wrap {
        display: flex;
        flex-direction: column;
        border: 1px solid #d8dee1;
        border-radius: 12px;
        padding: 24px;
        margin-top: 24px;
        width: 960px;
        box-sizing: border-box;

        .membership-info {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-direction: column;

          .card-logo {
            width: 100%;
            height: 45px;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            img {
              max-width: 100%;
              max-height: 100%;
              display: block;
            }
          }

          .membership-no {
            @include font(24px, 700);
            line-height: 32px;
            color: #2f3438;
            margin-bottom: 8px;
          }

          .membership-others-info {
            display: flex;
            gap: 24px;
            @include font(16px, 400);
            line-height: 24px;
            color: #667077;
          }
        }
      }
    }

    .footer-btn {
      width: 960px;
      display: flex;
      margin-top: 40px;
      justify-content: space-between;

      .cancel-btn {
        @include font(22px, 600);
        border-radius: 8px;
        color: #163049;
        padding: 16px 40px;
        border: 2px solid #163049;
        background-color: #fff;
        cursor: pointer;
      }

      .confirm-btn {
        @include font(22px, 600);
        border-radius: 8px;
        color: #fff;
        padding: 16px 40px;
        background-color: #ba9252;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 26px;
          height: 26px;
          margin-right: 5px;

          @keyframes loading {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          animation: loading 1s linear infinite;
        }

        &.isLoading {
          color: #667077;
          background-color: #eceef0;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .remove-membership-container {
      flex-direction: column;

      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 22px;
        padding: 0;
      }
      .content-wrap {
        width: 100%;
        padding-bottom: 30px;
        .tips-title {
          @include font(14px, 600);
          line-height: 20px;
          margin-bottom: 12px;
        }
        .tips-desc {
          @include font(12px, 400);
          line-height: 18px;
          margin-bottom: 28px;
        }

        .card-wrap {
          width: 100%;
          display: flex;
          flex-direction: column;

          .membership-info {
            .membership-others-info {
              flex-direction: column;
              gap: 8px;
            }
          }
        }
      }

      .footer-btn {
        width: 100%;

        .cancel-btn {
          @include font(16px, 600);
          padding: 8px 16px;
        }

        .confirm-btn {
          @include font(16px, 600);
          padding: 8px 16px;

          img {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }
      }
    }
  }
</style>
